var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25027 6.5V8.16667M8.25027 11.5H8.25861M2.47677 14.8333H14.0238C15.3068 14.8333 16.1087 13.4444 15.4672 12.3333L9.69365 2.33333C9.05215 1.22222 7.4484 1.22222 6.8069 2.33333L1.03339 12.3333C0.391894 13.4444 1.19377 14.8333 2.47677 14.8333Z",
    stroke: "#D3A422",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.4f50399b328877ca9e9c7e70d71a4adb.svg";
export { ForwardRef as ReactComponent };